export const errorsES = {
  cannotGET: 'No se ha podido establecer conexión con el servidor',
  dashboard: 'Ir al dashboard'
}